import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from "react";
import { OnlineMenuModel } from "../api/model/response/OnlineMenuResponseModel";
import { LanguageModel } from "../api/model/response/LanguageModel";
import {
  CompanyInfoModel,
  CompanyProduct
} from "../api/model/response/CompanyInfoModel";
import { HomeModel } from "../api/model/response/HomeModel";

const dataInitial = {} as OnlineMenuModel;
const dataInitialLang = [] as LanguageModel[];
const dataInitialCompany = {} as CompanyInfoModel;
const dataInitialHome = {} as HomeModel;
const dataInitialCompanyProduct = [] as CompanyProduct[];

interface UserContextProps {
  companyProduct: CompanyProduct[];
  setCurrentCompanyProduct: Dispatch<SetStateAction<CompanyProduct[]>>;
  homeData: HomeModel;
  setCurrentHomeData: Dispatch<SetStateAction<HomeModel>>;
  currentOnlineMenu: OnlineMenuModel;
  setCurrentOnlineMenu: Dispatch<SetStateAction<OnlineMenuModel>>;
  currentLanguagesList: LanguageModel[];
  setCurrentLanguagesList: Dispatch<SetStateAction<LanguageModel[]>>;
  selectedLanguage: string;
  setSelectedLanguage: Dispatch<SetStateAction<string>>;
  currentCompanyInfo: CompanyInfoModel;
  setCurrentCompanyInfo: Dispatch<SetStateAction<CompanyInfoModel>>;
}

export const UserContext = createContext<UserContextProps>({
  currentOnlineMenu: dataInitial,
  currentCompanyInfo: dataInitialCompany,
  selectedLanguage: dataInitialCompany,
  currentLanguagesList: dataInitialLang,
  homeData: dataInitialHome,
  companyProduct: dataInitialCompanyProduct
} as UserContextProps);

export const UserProvider = (props: { children: ReactNode }) => {
  const [currentMenu, setCurrentOnlineMenu] =
    useState<OnlineMenuModel>(dataInitial);
  const [currentLangs, setCurrentLanguages] =
    useState<LanguageModel[]>(dataInitialLang);
  const [currentCompany, setCurrentCompany] =
    useState<CompanyInfoModel>(dataInitialCompany);
  const [selectedLanguage, setSelectedLanguage] =
    useState<string>("");
  const [currentHome, setCurrentHome] = useState<HomeModel>(dataInitialHome);
  const [currentCompanyProduct, setCurrentCompanyProducts] = useState<
    CompanyProduct[]
  >(dataInitialCompanyProduct);

  return (
    <UserContext.Provider
      value={{
        companyProduct: currentCompanyProduct,
        setCurrentCompanyProduct: setCurrentCompanyProducts,
        homeData: currentHome,
        setCurrentHomeData: setCurrentHome,
        currentCompanyInfo: currentCompany,
        selectedLanguage: selectedLanguage,
        currentOnlineMenu: currentMenu,
        currentLanguagesList: currentLangs,
        setCurrentOnlineMenu: setCurrentOnlineMenu,
        setSelectedLanguage: setSelectedLanguage,
        setCurrentCompanyInfo: setCurrentCompany,
        setCurrentLanguagesList: setCurrentLanguages
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
